import styled from 'styled-components'

export const Overlay = styled.div`
  align-items: center;
  backdrop-filter: blur(2px);
  background: ${({ theme }) => theme.palette.colors.cardOverlayEnd};
  display: flex;
  flex-direction: column;
  gap: 9px;
  inset: 0;
  justify-content: center;
  pointer-events: none;
  position: absolute;
  z-index: 8;
`

export const LockBadge = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.palette.colors.surfaceElevatedStrong};
  border: 1px solid ${({ theme }) => theme.palette.colors.borderStrong};
  border-radius: 999px;
  color: ${({ theme }) => theme.palette.colors.text};
  display: flex;
  height: 48px;
  justify-content: center;
  width: 48px;
`

export const LockLabel = styled.div`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 13px;
  font-weight: 800;
  letter-spacing: .02em;
`
